import type { NotificationSchedulerProps } from '@/utils/hooks/context/toast/types';

// Components
import PostPublishFailed from '@/components/composite/Notifications/Scheduler/PostPublishFailed';

const NotificationsScheduler = ({ notification }: NotificationSchedulerProps) => {
    const type = notification.type;

    if (type === 'post_publish_failed') {
        return <PostPublishFailed notification={notification} />;
    }

    return null;
};

export default NotificationsScheduler;
